import React, { useEffect } from 'react';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  /** Optional class for the overlay (e.g. "template-overlay") */
  overlayClassName?: string;
  /** Optional class for the modal content (e.g. "template-modal") */
  modalClassName?: string;
}

/**
 * Generic overlay modal with backdrop click to close and optional header.
 */
export function Modal({
  open,
  onClose,
  title,
  children,
  overlayClassName = 'template-overlay',
  modalClassName = 'template-modal',
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={overlayClassName} onClick={onClose}>
      <div className={modalClassName} onClick={e => e.stopPropagation()}>
        {title != null && (
          <div className="template-modal-header">
            <h2>{title}</h2>
            <button type="button" className="close-btn" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export default Modal;
